var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<span>{{min}}:{{sec}} </span>";
ngModule.run(["$templateCache",function(c){c.put("sendsms/templates/sendsms.html",v1)}]);
module.exports=v1;


/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/sendsms/templates/sendsms.html
 ** module id = 572
 ** module chunks = 1
 **/